<script>
	import { getContext, onDestroy, onMount } from 'svelte'
	import * as animateScroll from 'svelte-scrollto'
	import { url } from '../scripts/Setup.svelte'
	import { flip } from 'svelte/animate'
	import { styles } from '../scripts/styles'
	import { storeSelectedTool, storeData, storeShowTools, storeShowGallery } from '../scripts/Store.svelte'
	import Shader from '../ShadersAndSpinners/Shader.svelte'
	import Spinner from '../ShadersAndSpinners/SpinnerCircle.svelte'
	import IntersectionObserver from 'svelte-intersection-observer'

	export let content
	export let showTitle = true
	export let showText = true

	// overwrite scroll
	animateScroll.setGlobalOptions({
		offset: -30,
	})

	//observer
	let element
	let large = false
	const set_observer = (e) => {
		if (e === 'set') {
			large = false
		} else {
			large = true
		}
	}

	const globals = getContext('globals')
	const fsS = globals.fsS
	const devWidth = globals.devWidth
	const isMobi = globals.mobi
	const icon = globals.iconSmall
	const colorError = globals.colorError
	const colorOK = globals.colorOk

	let folder
	// desktop & notebook
	if (!isMobi) {
		if (devWidth >= 1440) folder = '/medium/'
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		if (devWidth < 800) folder = '/small/'
	}

	// mobile devices
	if (isMobi) {
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		else folder = '/small/'
	}

	let images = []
	let configFile
	let data
	let showTools
	let path
	let thumbPath
	let sliderWidth
	let modalBg
	let modalArrows
	let modalArrowsHover
	let transitionSpeed = 2000
	let bgHeight = 'fit-content'

	//large devices
	if (window.innerHeight > 800) bgHeight = '100vh'

	const stoData = storeData.subscribe((value) => {
		if (value) {
			configFile = value
			data = value.blocks

			data.forEach((value) => {
				if (value.blockName === 'gallery') {
					sliderWidth = value.sliderWidth + 'vw'
					modalBg = value.modalBackground
					modalArrows = value.modalArrows
					modalArrowsHover = value.modalArrowsHover
				}
			})
		}
	})

	const stoShowTools = storeShowTools.subscribe((value) => {
		showTools = value
	})

	$: if (showTools) {
		storeSelectedTool.set('GalleryModal')
	}

	for (let key in content) {
		if (content[key].image) {
			path = url + '/gallery' + folder + content[key].image
			thumbPath = url + '/gallery/thumbnail' + '/' + content[key].image
		}

		images.push({
			path: path,
			thumbPath: thumbPath,
			name: 'gallery' + content[key]['id'],
			id: 'gsld' + content[key]['id'],
			title: content[key]['title'],
			text: content[key]['text'],
		})
	}

	let loaded = false

	//timeouts
	let toSlide

	const rotate_left = (e) => {
		const transitioningImage = images[images.length - 1]
		if (document.getElementById(transitioningImage.id) == null) return
		document.getElementById(transitioningImage.id).style.opacity = 0
		if (showTitle) document.getElementById(transitioningImage.name + '_title').style.opacity = 0
		if (showText) document.getElementById(transitioningImage.name + '_text').style.opacity = 0
		images = [images[images.length - 1], ...images.slice(0, images.length - 1)]
		toSlide = setTimeout(() => {
			document.getElementById(transitioningImage.id).style.opacity = 1
			if (showTitle) document.getElementById(transitioningImage.name + '_title').style.opacity = 1
			if (showText) document.getElementById(transitioningImage.name + '_text').style.opacity = 1
		}, transitionSpeed)
	}

	const rotate_right = (e) => {
		const transitioningImage = images[0]
		if (document.getElementById(transitioningImage.id) == null) return
		document.getElementById(transitioningImage.id).style.opacity = 0
		if (showTitle) document.getElementById(transitioningImage.name + '_title').style.opacity = 0
		if (showText) document.getElementById(transitioningImage.name + '_text').style.opacity = 0
		images = [...images.slice(1, images.length), images[0]]
		toSlide = setTimeout(() => {
			if (document.getElementById(transitioningImage.id) == null) return
			document.getElementById(transitioningImage.id).style.opacity = 1
			if (showTitle) document.getElementById(transitioningImage.name + '_title').style.opacity = 1

			if (showText) document.getElementById(transitioningImage.name + '_text').style.opacity = 1
		}, transitionSpeed)
	}

	const galleryBlock = document.getElementById('galleryBlock')
	animateScroll.scrollTo({ y: parseInt(galleryBlock.offsetHeight) + parseInt(galleryBlock.offsetTop) })

	const close_gallery = () => {
		storeShowGallery.set(false)
		animateScroll.scrollTo({ element: '#gallery_blockTitle' })
	}

	onMount(() => {
		loaded = true
	})

	onDestroy(() => {
		stoData
		stoShowTools
		clearTimeout(toSlide)
	})
</script>

{#if configFile}
	<main id="gallery_container" use:styles={{ modalBg }} bind:this={element}>
		<div class="gallery_container_outer">
			<div class="close_bar">
				<div
					class="close_icon"
					on:click={close_gallery}
					on:keydown={close_gallery}
					use:styles={{ icon, colorError, colorOK }}
				/>
			</div>

			<div class="gallery_container" id="gallery_container">
				<div class="gallery_container">
					<div class="controlLeft">
						<div
							class="buttonLeft"
							use:styles={{ modalArrows, modalArrowsHover }}
							on:click={rotate_left}
							on:keydown={rotate_left}
						/>
					</div>
					<IntersectionObserver
						{element}
						threshold="0.5"
						on:observe={(e) => {
							if (!e.detail.isIntersecting) {
								set_observer('set')
							} else {
								set_observer('unset')
							}
						}}
					>
						<div class="slider_container" bind:this={element}>
							{#each data as block}
								{#if block.blockName === 'gallery'}
									<div id="gallery" class="slide">
										<div
											class="slider_width"
											use:styles={{ sliderWidth }}
											style="
							position: relative;
							display: flex;
							flex-direction: column;
							align-items: center;
							height: 100%;
							"
										>
											<div
												style="
								position: relative;
								display: flex;
								justify-content: center;
								height: 100%;
								width:100%;
								overflow: hidden;
								"
											>
												<div class="sliderContainer">
													{#each images as image (image.id)}
														<div animate:flip={{ duration: transitionSpeed }}>
															{#if showTitle}
																<div
																	id="csTitleContainer"
																	style="
													display: flex;
													width: 100%;
													height: {block.sliderInsetTitleHeight}px;
													justify-content: center;
													align-items: center;
													color: {block.blockTitleColor};
													background-color: transparent;
													border-top-left-radius : {block.sliderInsetTitleBTradius}px;
													border-top-right-radius : {block.sliderInsetTitleBTradius}px;
													border-bottom-left-radius: {block.sliderInsetTitleBBradius}px;
													border-bottom-right-radius: {block.sliderInsetTitleBBradius}px;
													border-left-width:{block.sliderInsetTitleBLwidth}px;
													border-left-style:{block.sliderInsetTitleBLstyle};
													border-left-color:{block.sliderInsetTitleBLcolor};
													border-top-width:{block.sliderInsetTitleBTwidth}px;
													border-top-style:{block.sliderInsetTitleBTstyle};
													border-top-color:{block.sliderInsetTitleBTcolor};
													border-right-width:{block.sliderInsetTitleBRwidth}px;
													border-right-style:{block.sliderInsetTitleBRstyle};
													border-right-color:{block.sliderInsetTitleBRcolor};
													border-bottom-width:{block.sliderInsetTitleBBwidth}px;
													border-bottom-style: {block.sliderInsetTitleBBstyle};
													border-bottom-color:{block.sliderInsetTitleBBcolor};
													overflow: hidden;
													margin-bottom:30px;
													"
																>
																	<div class="text" id={image.name + '_title'}>
																		{#if image.title}
																			<div
																				class="title"
																				style="
																	font-family:{block.sliderInsetTitleFont};
																	color:{block.sliderInsetTitleColor};
																	font-size:{block.sliderInsetTitleSize};
																	font-weight:{block.sliderInsetTitleWeight};
																	font-style:{block.sliderInsetTitleStyle};
																	text-decoration:{block.sliderInsetTitleDeco};
																	"
																			>
																				{image.title}
																			</div>
																		{/if}
																	</div>
																</div>
															{/if}
															{#if large}
																<img
																	style="
												height: {block.sliderHeight}vw;
												width: {block.sliderWidth}vw;
												border-left:{block.sliderBLwidth}px solid {block.sliderBLcolor};
												border-top:{block.sliderBTwidth}px  {block.sliderBTstyle} {block.sliderBTcolor};
												border-right:{block.sliderBRwidth}px {block.sliderBRstyle} {block.sliderBRcolor};
												border-bottom:{block.sliderBBwidth}px {block.sliderBBstyle} {block.sliderBBcolor};
												"
																	src={image.path}
																	id={image.id}
																	alt={image.name}
																/>
															{:else}
																<img
																	style="
												height: {block.sliderHeight}vw;
												width: {block.sliderWidth}vw;
												border-left:{block.sliderBLwidth}px solid {block.sliderBLcolor};
												border-top:{block.sliderBTwidth}px  {block.sliderBTstyle} {block.sliderBTcolor};
												border-right:{block.sliderBRwidth}px {block.sliderBRstyle} {block.sliderBRcolor};
												border-bottom:{block.sliderBBwidth}px {block.sliderBBstyle} {block.sliderBBcolor};
												"
																	src={image.thumbPath}
																	id={image.id}
																	alt={image.name}
																/>
															{/if}

															{#if showText}
																<div
																	id="csTxtContainer"
																	style="
													display: flex;
													width: 100%;
													height: {block.sliderInsetTextHeight}px;
													justify-content: center;
													align-items: center;
													color: {block.blockTitleColor};
													background-color: transparent;
													border-top-left-radius : {block.sliderInsetTextBTradius}px;
													border-top-right-radius : {block.sliderInsetTextBTradius}px;
													border-bottom-left-radius: {block.sliderInsetTextBBradius}px;
													border-bottom-right-radius: {block.sliderInsetTextBBradius}px;
													border-left-width:{block.sliderInsetTextBLwidth}px;
													border-left-style:{block.sliderInsetTextBLstyle};
													border-left-color:{block.sliderInsetTextBLcolor};
													border-top-width:{block.sliderInsetTextBTwidth}px;
													border-top-style:{block.sliderInsetTextBTstyle};
													border-top-color:{block.sliderInsetTextBTcolor};
													border-right-width:{block.sliderInsetTextBRwidth}px;
													border-right-style:{block.sliderInsetTextBRstyle};
													border-right-color:{block.sliderInsetTextBRcolor};
													border-bottom-width:{block.sliderInsetTextBBwidth}px;
													border-bottom-style: {block.sliderInsetTextBBstyle};
													border-bottom-color:{block.sliderInsetTextBBcolor};
													overflow: hidden;
													"
																>
																	<div
																		class="text"
																		style="
															font-family:{block.sliderInsetTextTextFont};
															color:{block.sliderInsetTextTextColor};
															font-size:{fsS};
															font-weight:{block.sliderInsetTextTextWeight};
															font-style:{block.sliderInsetTextTextStyle};
															"
																		id={image.name + '_text'}
																	>
																		{#if image.text}
																			<div
																				class="text"
																				style="
																	font-family:{block.sliderInsetTextFont};
																	color:{block.sliderInsetTextColor};
																	font-size:{fsS};
																	font-weight:{block.sliderInsetTextWeight};
																	font-style:{block.sliderInsetTextStyle};
																	"
																			>
																				{image.text}
																			</div>
																		{/if}
																	</div>
																</div>
															{/if}
														</div>
													{/each}
												</div>
											</div>
										</div>
									</div>
								{/if}
							{/each}
						</div>
					</IntersectionObserver>
					<div class="controlRight">
						<div
							class="buttonRight"
							use:styles={{ modalArrows, modalArrowsHover }}
							on:click={rotate_right}
							on:keydown={rotate_right}
						/>
					</div>
				</div>
			</div>
		</div>
	</main>
{/if}

{#if !loaded}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" info="slider loading" />
		</div>
	</Shader>
{/if}

<style>
	main {
		display: flex;
		flex-direction: column;
		background-color: var(--modalBg);
		height: fit-content;
	}

	.gallery_container_outer {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100vw;
	}

	.gallery_container {
		display: flex;
		justify-content: space-around;
		align-items: center;
		width: 100%;
		height: fit-content;
		padding: 20px 0px 20px 0;
	}

	.close_bar {
		display: flex;
		justify-content: flex-end;
		width: 100%;
		margin-top: 50px;
	}

	.slide {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: fit-content;
	}
	.slider_width {
		width: var(--sliderWidth);
	}

	.close_icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		border-radius: 2px;
		cursor: pointer;
		margin-right: 50px;
	}

	.close_icon::after,
	.close_icon::before {
		content: '';
		display: block;
		width: var(--icon);
		background-color: var(--colorOK);
		margin-top: -3px;
		height: 3px;
		cursor: pointer;
	}

	.close_icon::before {
		-webkit-transform: rotate(-45deg);
		-ms-transform: rotate(-45deg);
		transform: rotate(-45deg);
	}
	.close_icon::after {
		-webkit-transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		transform: rotate(45deg);
	}

	.close_icon:hover::after,
	.close_icon:hover::before {
		background-color: var(--colorError);
	}
	.sliderContainer {
		display: flex;
	}

	.text,
	.title {
		display: flex;
		flex-direction: column;
		align-items: center;
		min-width: 100%;
		text-align: center;
		padding: 5%;
	}

	.controlLeft,
	.controlRight {
		display: flex;
		align-items: center;
		width: clamp(1rem, 2vw, 1.8rem);
		height: 100%;
		margin-right: clamp(0.7rem, 1.3vw, 1rem);
		margin-left: clamp(0.7rem, 1.3vw, 1rem);
	}

	.buttonRight {
		width: 0;
		height: 0;
		border-top: clamp(0.7rem, 2vw, 1.8rem) solid transparent;
		border-bottom: clamp(0.7rem, 2vw, 1.8rem) solid transparent;
		border-left: clamp(0.7rem, 2vw, 1.8rem) solid var(--modalArrows);
		cursor: pointer;
	}

	.buttonLeft {
		width: 0;
		height: 0;
		border-top: clamp(0.7rem, 2vw, 1.8rem) solid transparent;
		border-bottom: clamp(0.7rem, 2vw, 1.8rem) solid transparent;
		border-right: clamp(0.7rem, 2vw, 1.8rem) solid var(--modalArrows);
		cursor: pointer;
	}

	.buttonRight:hover {
		border-left: clamp(0.7rem, 2vw, 1.8rem) solid var(--modalArrowsHover);
	}

	.buttonLeft:hover {
		border-right: clamp(0.7rem, 2vw, 1.8rem) solid var(--modalArrowsHover);
	}
</style>
